<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label">{{ getTitle() }}</span>
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="pt-1">
  <div style="background: #e3f2fd; padding: 12px; border-radius: 6px; margin-bottom: 16px; border-left: 4px solid #2196f3;">
    <div style="display: flex; align-items: center; margin-bottom: 8px;">
      <mat-icon style="color: #2196f3; margin-right: 8px; font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
      <strong style="color: #1976d2;">Save Your Pattern</strong>
    </div>
    <div style="font-size: 13px; color: #555; line-height: 1.5;">
      Give your pattern a memorable name and optional description. Choose a category to organize your work.
    </div>
  </div>
  
  <mat-form-field class="full-width">
    <input
      matInput
      #nameInput
      placeholder="{{ httpService.getTransation().Name }}"
      [(ngModel)]="pattern.name"
      required
    />
    <mat-hint>Example: "Sunset Landscape" or "Cute Cat Portrait"</mat-hint>
    <mat-error>Name is required</mat-error>
  </mat-form-field>
  <mat-form-field class="full-width">
    <input
      matInput
      placeholder="{{ httpService.getTransation().Description }}"
      [(ngModel)]="pattern.description"
    />
    <mat-hint>Optional: Add notes about colors, size, or inspiration</mat-hint>
  </mat-form-field>
  <div style="display: flex; flex-direction: row; align-items: center">
    <mat-form-field fxFlex="50">
      <mat-select
        [(value)]="selectedCategory"
        placeholder="{{ httpService.getTransation().Category }}"
        (selectionChange)="onCategorySelected(selectedCategory)"
      >
        <mat-option *ngFor="let c of categories" [value]="c"
          >{{ c.name }}</mat-option
        >
      </mat-select>
      <mat-hint>Organize patterns by theme or project</mat-hint>
    </mat-form-field>
    <button
      mat-icon-button
      title="{{ httpService.getTransation().AddCategory }}"
      (click)="onAddCategory()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button
      mat-icon-button
      title="{{ httpService.getTransation().EditCategory }}"
      [disabled]="!selectedCategory || selectedCategory.categoryId === 0"
      (click)="onEditCategory()"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button
      mat-icon-button
      title="{{ httpService.getTransation().DeleteCategory }}"
      [disabled]="!selectedCategory || selectedCategory.categoryId === 0"
      (click)="onDeleteCategory()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button 
    mat-raised-button 
    color="primary" 
    (click)="onSubmit()"
    style="min-width: 120px;"
  >
    💾 {{ httpService.getTransation().Ok }}
  </button>
  <button mat-raised-button cdkFocusInitial (click)="onCancel()">
    {{ httpService.getTransation().Cancel }}
  </button>
</div>
